import BanzaiReferentialService from '@/services/banzai-referential.service'
import {AxiosInstance} from 'axios'
import _Vue from 'vue'

export default {
  install (
    Vue: typeof _Vue,
    { http }: { http: AxiosInstance }) {
    Vue.prototype.$banzaiReferential = new BanzaiReferentialService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiReferential: BanzaiReferentialService;
  }
}
